module.exports = __webpack_public_path__ + "img/960.9ab5f64a.svg";